export default __webpack_public_path__ + "static/media/animation-outil-de-mesure.f48fb473.gif";